// extracted by mini-css-extract-plugin
export default {"hamburger_icon":"HamburgerIcon_hamburger_icon__SvUbD","open":"HamburgerIcon_open__Cmcjw"};